var _line, _circle, _circle2, _circle3, _path, _line2, _line3, _circle4, _circle5, _circle6, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiagramC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.66,
    height: 59.82,
    viewBox: "0 0 58.66 59.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(0.75 0.75)",
    style: {
      isolation: "isolate"
    }
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    y2: 6.568,
    transform: "translate(34.673 12.357)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 6.562,
    cy: 6.562,
    r: 6.562,
    transform: "translate(28.111)",
    fill: "#aae2d0",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 6.562,
    cy: 6.562,
    r: 6.562,
    transform: "translate(12.029 22.736)",
    fill: "#aae2d0",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 6.562,
    cy: 6.562,
    r: 6.562,
    transform: "translate(44.035 22.736)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M648.085,2545.574v-2.634a1.336,1.336,0,0,1,1.336-1.338h29.258a1.338,1.338,0,0,1,1.338,1.338v2.634",
    transform: "translate(-629.435 -2522.838)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    y2: 5.349,
    transform: "translate(18.654 35.861)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    y2: 9.334,
    transform: "translate(50.597 35.861)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 6.562,
    cy: 6.562,
    r: 6.562,
    transform: "translate(0 45.195)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 6.562,
    cy: 6.562,
    r: 6.562,
    transform: "translate(24.183 45.195)",
    fill: "#aae2d0",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 6.562,
    cy: 6.562,
    r: 6.562,
    transform: "translate(44.035 45.195)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M640.946,2558.939v-2.671a1.336,1.336,0,0,1,1.336-1.338h21.481a1.336,1.336,0,0,1,1.336,1.338v2.634",
    transform: "translate(-634.326 -2513.708)",
    fill: "none",
    stroke: "#424242",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramC);
export default __webpack_public_path__ + "static/media/diagram-c.6df89b9a.svg";
export { ForwardRef as ReactComponent };